var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1989_78184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0005 15.9995L12.0005 11.9995M12.0005 11.9995L8.00045 15.9995M12.0005 11.9995V20.9995M20.3904 18.3895C21.3658 17.8578 22.1363 17.0164 22.5803 15.9981C23.0244 14.9799 23.1167 13.8427 22.8427 12.7662C22.5686 11.6896 21.9439 10.735 21.0671 10.0529C20.1903 9.37088 19.1113 9.00023 18.0005 8.9995H16.7405C16.4378 7.82874 15.8736 6.74183 15.0904 5.82049C14.3072 4.89915 13.3253 4.16735 12.2185 3.6801C11.1118 3.19286 9.909 2.96285 8.70057 3.00738C7.49213 3.0519 6.30952 3.3698 5.24163 3.93716C4.17374 4.50453 3.24836 5.3066 2.53507 6.28308C1.82178 7.25956 1.33914 8.38503 1.12343 9.57489C0.907718 10.7647 0.964554 11.988 1.28966 13.1528C1.61477 14.3175 2.19969 15.3934 3.00045 16.2995",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1989_78184"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/Import.17f30385d44ea3f9dc0b2d3906f45cdb.svg";
export { ForwardRef as ReactComponent };